import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=80d64a80"
import script from "./DateRangePicker.vue?vue&type=script&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports